import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getLink, getPage, needHeader, getHomeLinks } from "../dataProvider/links.js"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes, faUser, faChevronUp, faChevronDown, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { connect } from 'react-redux'
import { logoutUser } from '../actions/user.js'
import TopBanner from './topBanner.jsx';

import flagFrench from '../img/v1/header/flagFrench.png'
import flagEnglish from '../img/v1/header/flagEnglish.png'
import flagSpanish from '../img/v1/header/flagSpanish.png'
import LogoV2 from "../img/v2/logo.png"
import convertIconV2 from "../img/v2/user/convert.png"
import compressIconV2 from "../img/v2/user/compress-icon.png"
import splitIconV2 from "../img/v2/user/split-pdf.png"

import "../scss/v2/header.scss"

function Header(props) {

    const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(true)
    const [display, setDisplay] = useState(false)
    const [hover, setHover] = useState(false)
    const [isWideScreen, setIsWideScreen] = useState(false);
    const { t, i18n } = useTranslation();
    let collapse = useRef(null);
    let collapseButton = useRef(null);
    let location = useLocation();
    let navigate = useNavigate();

    useEffect(() => {
        const handleClickEvent = e => {
            // Do nothing if click on button
            if (collapseButton.current === null || collapseButton.current === e.target || collapseButton.current.contains(e.target)) return;
            if (!isNavbarCollapsed && e.target !== collapse.current && !collapse.current.contains(e.target)) setIsNavbarCollapsed(true);
        }

        window.addEventListener("click", handleClickEvent);

        return () => {
            window.removeEventListener("click", handleClickEvent);
        }
    }, [collapse, collapseButton, isNavbarCollapsed])

    useEffect(() => {
        const whenResized = () => {
            setIsWideScreen(window.innerWidth > 1200 ? true : false);
        };

        window.addEventListener("resize", whenResized);
        whenResized();
        return () => window.removeEventListener("resize", whenResized);
    }, [])

    const isPageActive = (page) => location.pathname === getLink(page, i18n.language)

    function setLang(lang) {
        const actualPage = getPage(location.pathname, i18n.language);
        return navigate(getLink(actualPage, lang))
    }

    const getHIWLink = () => {
        const homeLinks = getHomeLinks() || [];

        const actualLink = getPage(location.pathname, i18n.language)

        let baseLink = homeLinks.find(possibleLink => actualLink === possibleLink) || "home"
        let link = `${getLink(baseLink, i18n.language)}#how-it-works`;
        if (`${location.pathname}${location.hash}` === link) {
            link = `${getLink(baseLink, i18n.language)}#howItWorks`;
        }
        return link;
    }

    function getActiveLanguage() {
        switch (i18n.language) {
            case "es":
                return flagSpanish;

            case "fr":
                return flagFrench;

            default:
                return flagEnglish;
        }
    }

    const renderNavbarBrand = () => {
        return (
            <Navbar.Brand href={getLink((props.user && props.user.connected) ? "account" : "home", i18n.language)}>
                <div className="header-brand">
                    <img className="img img-fluid header-logo" src={LogoV2} alt={LogoV2} />
                    <span className="header-brand-name">{t('brand.name')}</span>
                </div>
            </Navbar.Brand>
        )

    }

    const renderHeaderLinks = () => {
        return (
            <>
                <Link to={getLink("home", i18n.language)} className="header-sublink" onClick={() => { setIsNavbarCollapsed(true); setHover(false); setDisplay(false) }}>
                    <div className="header-sublink-image-container">
                        <img className="img img-fluid header-sublink-image" src={convertIconV2} alt={convertIconV2} />
                    </div>
                    <div className="header-sublink-text-container">
                        <span className="header-sublink-text">{t("header.sublink.convert.text")}</span>
                        <span className="header-sublink-subtext">{t("header.sublink.convert.subtext")}</span>
                    </div>
                </Link>
                <Link to={getLink("compress", i18n.language)} className="header-sublink" onClick={() => { setIsNavbarCollapsed(true); setHover(false); setDisplay(false) }}>
                    <div className="header-sublink-image-container">
                        <img className="img img-fluid header-sublink-image" src={compressIconV2} alt={compressIconV2} />
                    </div>
                    <div className="header-sublink-text-container">
                        <span className="header-sublink-text">{t("header.sublink.compress.text")}</span>
                        <span className="header-sublink-subtext">{t("header.sublink.compress.subtext")}</span>
                    </div>
                </Link>
                <Link to={getLink("splitPdf", i18n.language)} className="header-sublink" onClick={() => { setIsNavbarCollapsed(true); setHover(false); setDisplay(false) }}>
                    <div className="header-sublink-image-container">
                        <img className="img img-fluid header-sublink-image" src={splitIconV2} alt={splitIconV2} />
                    </div>
                    <div className="header-sublink-text-container">
                        <span className="header-sublink-text">{t("header.sublink.split.text")}</span>
                        <span className="header-sublink-subtext">{t("header.sublink.split.subtext")}</span>
                    </div>
                </Link>
            </>
        )
    };

    function renderCollapse() {
        return (
            <>
                <div className="d-block d-xl-none ml-auto">
                    <a className="header-mobile-contact" href={`tel:${t('footer.link.contact.phone.number')}`} target="_blank" rel="noopener noreferrer">
                        <div className="header-mobile-contact-icon-container">
                            <FontAwesomeIcon icon={faPhone} />
                        </div>
                    </a>
                    <Link className="header-mobile-contact" to={getLink("contact", i18n.language)}>
                        <div className="header-mobile-contact-icon-container">
                            <FontAwesomeIcon icon={faEnvelope} />
                        </div>
                    </Link>
                </div>
                <Navbar.Toggle ref={collapseButton} onClick={() => { setIsNavbarCollapsed(!isNavbarCollapsed) }}>
                    <FontAwesomeIcon icon={faBars} className={isNavbarCollapsed ? '' : 'd-none'} />
                    <div className="closing-navbar-toggler">
                        <FontAwesomeIcon icon={faTimes} className={!isNavbarCollapsed ? '' : 'd-none'} />
                    </div>
                </Navbar.Toggle>
                <div id="header-navbar" className={(!isNavbarCollapsed || isWideScreen) ? 'd-flex' : 'd-none'} >
                    <div className="header-collapse-container">
                        <div className="header-collapse" ref={collapse} >
                            <Nav className="mx-auto">
                                <div className='header-link-tabs tab1'>
                                    <div className="d-none d-xl-inline-block header-hover-parent" onMouseEnter={() => { setHover(true) }} onMouseLeave={() => { setHover(false) }}>
                                        <Nav.Link eventKey="1" as={Link} to={getLink("home", i18n.language)} className="mx-auto header-link-container">
                                            <span className={`header-link${isPageActive("home") ? " active" : ""}`}>
                                                {t("header.link.home")}
                                            </span>
                                            <svg className={`header-link-svg${isPageActive("home") ? " active" : ""}`} width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.60627 3.85625L0.887524 1.1375C0.850024 1.1 0.821899 1.05938 0.803149 1.01563C0.784399 0.971875 0.775024 0.925 0.775024 0.875C0.775024 0.775 0.809399 0.6875 0.878149 0.6125C0.946899 0.5375 1.03752 0.5 1.15002 0.5H6.85002C6.96252 0.5 7.05315 0.5375 7.1219 0.6125C7.19065 0.6875 7.22502 0.775 7.22502 0.875C7.22502 0.9 7.18752 0.9875 7.11252 1.1375L4.39377 3.85625C4.33127 3.91875 4.26877 3.9625 4.20627 3.9875C4.14377 4.0125 4.07502 4.025 4.00002 4.025C3.92502 4.025 3.85627 4.0125 3.79377 3.9875C3.73127 3.9625 3.66877 3.91875 3.60627 3.85625Z" fill="#44A0FF" />
                                            </svg>
                                        </Nav.Link>
                                        <div className={`header-hover-hidden${hover ? " d-block" : " d-none"}`}>
                                            {renderHeaderLinks()}
                                        </div>
                                    </div>
                                    <div className="d-block d-xl-none">
                                        <Nav.Item className="header-mobile-home" onClick={() => { setDisplay(!display) }}>
                                            <span className={`header-link${isPageActive("home") ? " active" : ""}`}>{t("header.link.home")}</span>
                                            <div className="d-inline-block header-mobile-home-icon">
                                                {display ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                                            </div>
                                        </Nav.Item>
                                        <div className={display ? "d-block" : "d-none"}>
                                            {renderHeaderLinks()}
                                        </div>
                                    </div>
                                    <Nav.Link eventKey="2" as={Link} to={getHIWLink()} className="mx-2">
                                        <span className="header-link">{t("header.link.how")}</span>
                                    </Nav.Link>
                                    <Nav.Link eventKey="3" as={Link} to={getLink("faq", i18n.language)} className="mx-2">
                                        <span className={`header-link${isPageActive("faq") ? " active" : ""}`}>{t("header.link.faq")}</span>
                                    </Nav.Link>
                                    <Nav.Link eventKey="4" as={Link} to={getLink("pricing", i18n.language)} className="mx-2">
                                        <span className={`header-link${isPageActive("pricing") ? " active" : ""}`}>{t("header.link.price")}</span>
                                    </Nav.Link>
                                    <Nav.Link eventKey="5" as={Link} to={getLink("unsubscribe", i18n.language)} className="mx-2">
                                        <span className={`header-link${isPageActive("unsubscribe") ? " active" : ""}`}>{t("header.link.contact")}</span>
                                    </Nav.Link>
                                    <Nav.Link eventKey="5" as={Link} to={getLink("terminate", i18n.language)} className="mx-2">
                                        <span className={`header-link${isPageActive("terminate") ? " active" : ""}`}>{t("header.link.terminate")}</span>
                                    </Nav.Link>
                                </div>

                                <div className='header-link-tabs tab2'>
                                    {
                                        props.user && props.user.connected ? (
                                            <>
                                                <Nav.Link eventKey="6" as={Link} to={getLink("account", i18n.language)} className="mx-0 mt-1 d-none d-xl-flex">
                                                    <button className="button reversed-blue-button">{t("header.link.convert")}</button>
                                                </Nav.Link>
                                                <NavDropdown title={
                                                    <div className="header-account-image">
                                                        <FontAwesomeIcon icon={faUser} />
                                                    </div>
                                                } id="account-dropdown" alignRight className="mx-1 d-none d-xl-flex">
                                                    <NavDropdown.Item as={Link} to={getLink("account", i18n.language)} >
                                                        <span className={`account-dropdown-text${isPageActive("account") ? " active" : ""}`}>{t("header.link.account")}</span>
                                                    </NavDropdown.Item>
                                                    <NavDropdown.Item as={Link} to={getLink("manageAccount", i18n.language)} >
                                                        <span className={`account-dropdown-text${isPageActive("manageAccount") ? " active" : ""}`}>{t("header.link.manageAccount")}</span>
                                                    </NavDropdown.Item>
                                                    <NavDropdown.Item as={Link} to={getLink("invoice", i18n.language)}>
                                                        <span className="account-dropdown-text">{t("header.link.invoice")}</span>
                                                    </NavDropdown.Item>
                                                    <NavDropdown.Item as={Link} to={getLink("passwordChange", i18n.language)}>
                                                        <span className="account-dropdown-text">{t("header.link.changePassword")}</span>
                                                    </NavDropdown.Item>
                                                    <NavDropdown.Item onClick={() => { props.dispatch(logoutUser()) }}>
                                                        <span className="account-dropdown-text">{t('header.link.logout')}</span>
                                                    </NavDropdown.Item>
                                                </NavDropdown>
                                            </>
                                        ) : (
                                            <>
                                                <div className="header-collapse-separator" />
                                                <Nav.Link eventKey="6" as={Link} to={getLink("login", i18n.language)} className="mx-0">
                                                    <button className="button reversed-blue-button">{t("header.link.login")}</button>
                                                </Nav.Link>
                                            </>
                                        )
                                    }
                                    <NavDropdown title={
                                        <img className="img img-fluid header-lang-image"
                                            src={getActiveLanguage()}
                                            alt="header lang dropdown"
                                        />
                                    } id="lang-dropdown" alignRight className="mx-0">
                                        <NavDropdown.Item onClick={() => { setLang("en") }}>
                                            <div className={`flag-container${i18n.language === "en" ? " active" : ""}`}>
                                                <img className="img img-fluid flag-image" src={flagEnglish} alt={flagEnglish} />
                                                <span className="flag-text">{t('lang.english')}</span>
                                            </div>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => { setLang("fr") }}>
                                            <div className={`flag-container${i18n.language === "fr" ? " active" : ""}`}>
                                                <img className="img img-fluid flag-image" src={flagFrench} alt={flagFrench} />
                                                <span className="flag-text">{t('lang.french')}</span>
                                            </div>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => { setLang("es") }}>
                                            <div className={`flag-container${i18n.language === "es" ? " active" : ""}`}>
                                                <img className="img img-fluid flag-image" src={flagSpanish} alt={flagSpanish} />
                                                <span className="flag-text">{t('lang.spanish')}</span>
                                            </div>
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                    {
                                        props.user && props.user.connected ? (
                                            <div className="d-block d-xl-none">
                                                <div className="header-collapse-separator" />
                                                <Nav.Link eventKey="8" as={Link} to={getLink("account", i18n.language)} className="mx-auto">
                                                    <span className={`header-link${isPageActive("account") ? " active" : ""}`}>{t("header.link.account")}</span>
                                                </Nav.Link>
                                                <Nav.Link eventKey="9" as={Link} to={getLink("passwordChange", i18n.language)} className="mx-auto">
                                                    <span className={`header-link`}>{t("header.link.changePassword")}</span>
                                                </Nav.Link>
                                                <Nav.Link eventKey="10" className="mx-0" onClick={() => { props.dispatch(logoutUser()) }}>
                                                    <span className={`header-link`}>{t("header.link.logout")}</span>
                                                </Nav.Link>
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </Nav>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    function noNeedHeader() {
        return (
            <Navbar.Brand href={getLink(props.mode === "compress" ? "compress" : props.mode === "split" ? "splitPdf" : "home", i18n.language)}>
                <div className="header-brand">
                    <img className="img img-fluid header-logo" src={LogoV2} alt={LogoV2} />
                    <span className="header-brand-name">{t('brand.name')}</span>
                </div>
            </Navbar.Brand>
        )
    }

    return (
        <header className="header">
            <TopBanner />

            <div className="container">
                <Navbar expand="xl">
                    {!needHeader(location.pathname, i18n.language) ? (
                        noNeedHeader()
                    ) : (
                        <>
                            {renderNavbarBrand()}
                            {renderCollapse()}
                        </>
                    )}

                </Navbar>
            </div>
        </header>
    )
}


const mapStateToProps = state => ({ user: state.user.user, mode: state.mode.mode });

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Header);